import React, {useState, useEffect} from 'react'
import './ShareOptions.scss'
import {Form} from 'react-bootstrap'
import {useI18n} from '../../../../../Utils/_helpers/useI18n'
import {ShareMethod, ShareOptionsProps} from '../../type'
import {STEP_KEYS} from '../../../../../Utils/Constant/WalletCard'

const ShareOptions: React.FC<ShareOptionsProps> = ({
  cardData,
  handleChange,
  errors,
  isLoading,
  isExpanded = true,
  onExpand,
  isCompleted = false,
  setIsCompleted,
  gateUntilOpened,
}) => {
  const {t} = useI18n()
  const [isContentVisible, setIsContentVisible] = useState(isExpanded)
  const [hasOpenedOnce, setHasOpenedOnce] = useState<boolean>(isExpanded)

  useEffect(() => {
    // Check if at least one share method is selected
    const hasSelectedMethod: boolean = cardData.shareMethod && cardData.shareMethod.length > 0
    if (setIsCompleted) {
      setIsCompleted(hasSelectedMethod)
    }
  }, [cardData.shareMethod, setIsCompleted])

  useEffect(() => {
    setIsContentVisible(isExpanded)
    if (isExpanded) setHasOpenedOnce(true)
  }, [isExpanded])

  const toggleContent = () => {
    const newState = !isContentVisible
    setIsContentVisible(newState)
    if (newState && onExpand) {
      onExpand(STEP_KEYS.SHARE_CONTACT_DETAILS)
    }
    if (newState) setHasOpenedOnce(true)
  }

  const handleShareMethodChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, checked} = e.target
    const methodType = name === 'shareToWallet' ? ShareMethod.WALLET : ShareMethod.CONTACT
    let updatedShareMethod = [...(cardData.shareMethod || [])]

    if (checked) {
      !updatedShareMethod.includes(methodType) && updatedShareMethod.push(methodType)
    } else {
      updatedShareMethod = updatedShareMethod.filter((method) => method !== methodType)
    }

    handleChange({
      target: {
        name: 'shareMethod',
        value: updatedShareMethod,
      },
    })
  }



  return (
    <div
      className={`wizard-step share-options ${isExpanded ? 'border-primary' : ''} border bg-white`}
    >
      <div className={`wizard-step-header cursor-pointer ${isContentVisible ? 'border-radius-bottom-0' : 'border-radius-bottom'}`} onClick={toggleContent}>
        <div className='step-indicator'>
          <div className={`step-number ${isCompleted && !(gateUntilOpened && !hasOpenedOnce) ? 'completed' : 'border-secondary'} `}>
            <span></span>
            {isCompleted && !(gateUntilOpened && !hasOpenedOnce) && (
              <svg
                className='check-icon'
                width='12'
                height='9'
                viewBox='0 0 12 9'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M10.6668 1L4.00016 7.66667L1.3335 5'
                  stroke='currentColor'
                  strokeWidth='1.67'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            )}
          </div>
          <div className='step-title d-flex flex-column'>
            <h2 className={`${isExpanded ? 'text-primary' : 'text-dark'} fw-semibold fs-2`}>
              {t('WALLET_CARD.SHARE_OPTIONS.TITLE')}
            </h2>
            <span>{t('WALLET_CARD.SHARE_OPTIONS.SUBTITLE')}</span>
          </div>
          <h2 className={`${isExpanded ? 'text-primary' : 'text-muted'} fw-semibold fs-2 text-number-step`}>3</h2>
          <div className={`collapse-arrow ${!isContentVisible ? 'collapsed' : ''}`}>
            <svg
              width='10'
              height='6'
              viewBox='0 0 10 6'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M1 1L5 5L9 1'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </div>
      </div>

      <div className={`wizard-step-content ${!isContentVisible ? 'd-none' : 'p-4'}`}>
        <div className='share-options-form'>
          <div className='d-flex gap-2 justify-content-between'>
            <Form.Group>
              <Form.Label className='fw-bold'>{t('WALLET_CARD.FORM.SHARE_OPTIONS')}</Form.Label>
              <div className='d-flex gap-5 mt-2 share-options-container'>
                <Form.Check
                  id='shareToWallet'
                  type='checkbox'
                  label={t('WALLET_CARD.FORM.SHARE_OPTIONS.WALLET')}
                  name='shareToWallet'
                  checked={cardData.shareMethod?.includes(ShareMethod.WALLET)}
                  onChange={handleShareMethodChange}
                  disabled={isLoading}
                  className='input-share-options'
                />
                <Form.Check
                  id='shareToContact'
                  type='checkbox'
                  label={t('WALLET_CARD.FORM.SHARE_OPTIONS.CONTACT')}
                  name='shareToContact'
                  checked={cardData.shareMethod?.includes(ShareMethod.CONTACT)}
                  onChange={handleShareMethodChange}
                  disabled={isLoading}
                  className='input-share-options'
                />
              </div>
              {errors.shareMethod && (
                <div className='fv-plugins-message-container mt-2'>
                  <span role='alert' className='text-danger'>
                    {errors.shareMethod}
                  </span>
                </div>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShareOptions
